import styled from 'styled-components';

const Whitespace = styled.div`
  height: ${({ size }) => size};
`;

export default Whitespace;



// WEBPACK FOOTER //
// ./components/layout/Whitespace.js